/**
 * The window handed to the points/NFT endpoints.
 *
 * This used to be a hardcoded "epoch" (epoch 3, 2024-08-01 → 2024-09-30). That window closed long
 * ago, which switched off the live points ticker and every per-item progress readout, and left the
 * page showing 0 points. Epochs are gone from the UI, so the window is now simply all-time.
 *
 * Only a begin is sent. `StakePointsView` returns 0 unless a begin *or* end is present, so one is
 * required — but the end is better left off: server-side it lands in `StakeLog.with_seconds` as
 * `LEAST(end, unstaked_at, now())`, and Postgres LEAST ignores NULLs, so a missing end clamps to
 * `now()` on its own. `PointsRewardView` already calls `get_points()` with no window at all, so
 * this is a proven path.
 *
 * `begin` predates every BR1 stake record, making the window effectively unbounded.
 */
const BEGIN = new Date('2020-01-01T00:00:00Z')

export const useStakeWindow = () => {
    const params = new URLSearchParams({ epoch_begin: String(Math.floor(BEGIN.getTime() / 1000)) })
    return { begin: BEGIN, query: params.toString() }
}
